<template>
  <article class="modal_info">
    <section class="modal_info__modal" style="height:fit-content;border-radius:5px">
      <div class="modal_info__modal__info">
        <img src="@/assets/icono-alerta.svg" width="80" height="80" style="margin-bottom: 30px;">
        <h5>
            Ten en cuenta que al hacer cambios en horarios, cupos, 
            frecuencia de reservas o tiempo de estadía se verán afectados 
            los usuarios que tengan una reserva actual en la fecha a modificar.
        </h5>
        <h5>¿Deseas guardar la nueva configuración?</h5>
      </div>
      <div class="modal_info__modal__buttons">
          <button class="modal_info__modal__buttons--cancel" @click="closeModal()">NO</button>
          <button class="modal_info__modal__buttons--confirm" @click="confirmAction()">SI</button>
      </div>      
    </section>
  </article>
</template>

<script>
  export default {
    methods: {
      closeModal(){
        this.$emit('confirm-action', false);        
        this.updateIsInAlert(false);
      },
      confirmAction(){
        this.updateIsInAlert(false);
        this.$emit('confirm-action', true);   
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/ConfirmationModal.vue